import { FC, memo, useEffect, useRef, useState } from "react"
import { TypeSelectedData } from "../../types/TypeSelectedData"
import { Box, Card, CardBody, Grid, GridItem, Heading, Text } from "@chakra-ui/react"
import { ImageGallery } from "./ImageGallery"
import YouTube from "react-youtube"
import styles from "../../../css/nonScrollbar.module.scss"
import "../../../css/MobileDetailDialog.scss"
import { LikeButton } from "../useLikeButton"
import { ModalProgress } from "./ModalViewControl"
import { QRcode } from "./QRcode"
import { HeightCalculation, WidthCalculation } from "../../SizeCaluculation"

type Props = TypeSelectedData & {
  TypeMenu: string
  onClose: () => void
  LikeCount: number
  setLikeCount: React.Dispatch<React.SetStateAction<number>>
  ModalLayout: number
  isOpen: boolean
  paginate?: (newDirection: number) => void
  index?: number
  modalCanCloseFlag?: boolean
}

type MovieProps = {
  ModalLayout: number
  onClose: () => void
  setMoveEndFlag: (MoveEndFlag: boolean) => void
  modalCanCloseFlag?: boolean
  url: string
  CardHeight: number
}

export const Movie: FC<MovieProps> = (props) => {
  const { ModalLayout, onClose, setMoveEndFlag, modalCanCloseFlag, url, CardHeight } = props
  const videoRef = useRef<HTMLVideoElement>(null);
  const handleVideoEnd = () => {
    ModalLayout == 0 && onClose()
    ModalLayout == 1 && videoRef.current && videoRef.current.play();
    ModalLayout == 1 && setMoveEndFlag(true)
    modalCanCloseFlag && onClose()
  };
  return (
    <video
      autoPlay
      ref={videoRef}
      onEnded={handleVideoEnd}
      onError={() => ModalLayout == 1 && setMoveEndFlag(true)} // URLの期限切れなどのエラーで動画が表示されなかった時プログレスを進める
      style={{
        maxHeight: ModalLayout == 1 ? `${window.innerWidth * 0.44}px` : `${window.innerWidth * 0.46}px`,
        maxWidth: `${CardHeight * 0.9}px`
      }}
    >
      <source src={url} type="video/mp4" />
    </video>
  )
}

export const Body: FC<Props> = memo((props) => {
  // Props from Model
  const { Title, Medias, TopicBody, TypeMenu, isOpen, onClose, TopicID, LikeCount, setLikeCount, ModalLayout, paginate, index, modalCanCloseFlag } = props
  // Mediaの画像か動画か判断し取り出す
  const Media = Medias.find((media) => media.TYPE === "video");
  const [MoveEndFlag, setMoveEndFlag] = useState(false)

  // 本文の内容をurlと文で分ける 本文が存在しない場合は　partsを空配列に
  const parts = TopicBody ? TopicBody.split(/(https?:\/\/\S+)/) : [];

  // Cardの高さ
  const CardHeight = ModalLayout == 0 ? HeightCalculation(848, 653) : HeightCalculation(616, 653)
  let vId
  let timerId: NodeJS.Timer | undefined;

  useEffect(() => {
    if (ModalLayout == 0) {
      const TimerStart = () => {
        if (ModalLayout == 0) {
          timerId = setTimeout(() => {
            isOpen && onClose();
          }, 60000) //60秒経てば詳細画面が閉じる
        }
      }

      const handleTouch = () => {
        clearTimeout(timerId); // タッチイベントが発生したらタイマーをクリア
        TimerStart();
      }
      document.addEventListener('mousemove', handleTouch);
      document.addEventListener('touchstart', handleTouch);

      if (TypeMenu !== "youtube") {
        isOpen == true ? TimerStart() : clearTimeout(timerId);
      }
    }
  }, [isOpen])

  if (Media) {
    const parser = new URL(Media.URL);
    vId = parser.searchParams.get("v");
  }


  const _onReady = (event: any) => {
    // access to player in all event handlers via event.target
    if (event) {
      event.target.setVolume(100)
      event.target.playVideo && event.target.playVideo()
    }
  }
  const _onEnd = (event: any) => {
    ModalLayout == 0 && onClose()
    ModalLayout == 1 && event.target.playVideo && event.target.playVideo()
    ModalLayout == 1 && setMoveEndFlag(true)
    modalCanCloseFlag && onClose()

  }
  const opts = {
    width: ModalLayout == 1 ? `${window.innerWidth * 0.44}px` : `${window.innerWidth * 0.46}px`,
    height: `${CardHeight * 0.80}px`,
    playerVars: {
      autoPlay: 1,
      loop: 1,
      modestbranding: 1,
      fs: 0,
      controls: 0,
    },
  };

  return (
    <>
      {paginate && modalCanCloseFlag !== undefined && (index === 0 || index) &&
        <ModalProgress
          MoveEndFlag={MoveEndFlag}
          onClose={onClose}
          Media={Media}
          paginate={paginate}
          index={index}
          modalCanCloseFlag={modalCanCloseFlag}
        />
      }
      <Card
        direction="row"
        pt={`${HeightCalculation(32, 32)}px`}
        pl={`${WidthCalculation(60, 45)}px`}
        pr={`${WidthCalculation(34, 107)}px`}
        pb={`${HeightCalculation(32, 32)}px`}
        mb="0px"
        variant="outline"
        height={`${CardHeight}`}
        style={{
          border: "none",
          borderRadius: "0px 0px 16px 16px"
        }}
      >
        <Grid
          templateColumns={Medias.length < 1 ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}  // Medias が空の場合は 1 列、それ以外は 2 列
          gap={8}
          height="100%"
        >
          <GridItem
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{ zIndex: "1" }}
            colSpan={1}
            width={`${WidthCalculation(845, 464)}px`}
          >
            {(Media == undefined || Medias.length > 2) ?
              <ImageGallery
                Medias={Medias}
                parentHeight={CardHeight}
                ModalLayout={ModalLayout}
                onClose={onClose}
                setMoveEndFlag={setMoveEndFlag}
                modalCanCloseFlag={modalCanCloseFlag}
              /> :
              ((() => {
                if (TypeMenu == "youtube" && vId) {
                  return <YouTube
                    style={{ pointerEvents: "none" }}
                    opts={opts}
                    videoId={vId}
                    onReady={_onReady}
                    onEnd={_onEnd}
                    onError={() => ModalLayout == 1 && setMoveEndFlag(true)} // エラーで動画が表示されなかった時プログレスを進める
                  />;
                } else if (TypeMenu !== "youtube") {
                  return (
                    <Movie
                      ModalLayout={ModalLayout}
                      onClose={onClose}
                      setMoveEndFlag={setMoveEndFlag}
                      modalCanCloseFlag={modalCanCloseFlag}
                      url={Media.URL}
                      CardHeight={CardHeight}
                    />
                  )
                }
                return null;
              })()
              )}
          </GridItem>
          <GridItem
            className={`${styles.modalScrollbar} ${styles[TypeMenu]}`}
            overflow="auto"
            style={{ zIndex: "10" }}
            colSpan={1}
            width={Medias.length < 1 ? `${WidthCalculation(1728, 464)}px` : `${WidthCalculation(864, 464)}px`}
            height="100%"
          >
            <Box
              borderWidth="0"
              style={{ zIndex: "10", overflow: "auto" }}
              bg="transparent"
            >
              <CardBody style={{ zIndex: "10" }} >
                <Heading
                  className="heading"
                  mb={`${HeightCalculation(16, 16)}px`}
                  fontSize={`${HeightCalculation(36, 36)}px`}
                  lineHeight={`${HeightCalculation(50, 50)}px`}
                >
                  {Title}
                </Heading>
                <Box display="flex" pt="10px" pb="10px">
                  <LikeButton
                    TopicID={TopicID}
                    WallLike={LikeCount}
                    buttonColor={"#C53030"}
                    Size={"big"}
                    setLikeCount={setLikeCount}
                    ModalLayout={ModalLayout}
                  />
                </Box>
                {
                  parts.map((part, index) => {
                    if (part.startsWith("https://") || part.startsWith("http://")) {
                      return (
                        <div key={index} >
                          <QRcode url={part} />
                        </div>
                      )
                    } else {
                      return (
                        <Text
                          key={index}
                          className="body"
                          style={{ userSelect: "none" }}
                          whiteSpace="pre-wrap"
                          pt="16px"
                          fontSize={`${HeightCalculation(24, 24)}px`}
                          lineHeight={`${HeightCalculation(36, 36)}px`}
                          color="gray.700"
                        >
                          {part}
                        </Text>
                      )
                    }
                  })
                }
              </CardBody>
            </Box>
          </GridItem>
        </Grid>
      </Card>
    </>
  )
})
